module.exports = "query programPaths {\n  entries(section: [\"programs\"], limit: 1) {\n    id\n  }\n}"